import React, { useEffect, useState } from "react";
import { Button, Form, InputGroup } from "react-bootstrap";
import { Entity, Definition } from "../../data/Definition";
import { IItem } from "../../data/Query";

type SpatialFilterProps = {
    definition: Definition,
    item: IItem | null,
    onUpdate: Function
};

export const SpatialEntity = ({definition, item, onUpdate} : SpatialFilterProps) => {

    // select all the entites that can be used as a spatial filter.
    const spatialEntities: IItem[] = definition.entity.filter((item: Entity) => item.spatial)
        .map((item: Entity) => {
            return {
                item: item,
                sub: null
            };
        });

    if(definition.spatial) {
        spatialEntities.push({
            item: definition as Entity,
            sub: null
        });
    }

    const [config, setConfig] = useState<IItem | null>(null);
    const [current, setCurrent] = useState<IItem | null>(null);
    const [showConfig, setShowConfig] = useState(false);
    const [isConfigValid, setConfigIsValid] = useState(false);

    useEffect(() => {
        console.log('item updated', item);
        setCurrent(item);
    }, [item]);

    useEffect(() => {
        setConfig(current);
        setConfigIsValid(current != null);
    }, [showConfig]);

    useEffect(() => {
        setConfigIsValid(config != null);
    }, [config]);

    const getEntityDisplay = (item: IItem | null) : string => {
        if(item && item.item) {
            const entity = item.item as Entity;
            console.log('getEntityDisplay', entity);
            return `entity: ${entity.name}`;
        }

        return '';
    };

    const configItemChanged = (e: any) => {
        setConfig(spatialEntities[e.target.value]);
    };

    const saveOnClick = (save: boolean) => {
        if(save) {
            setCurrent(config);
            onUpdate(config);
        }

        setShowConfig(false);
    };

    const onClearSelected = () => {
        setCurrent(null);
        setConfig(null);

        onUpdate(null);
    }

    const renderCurrent = () => {
        return (
            showConfig ? "" :
                <InputGroup className="mb-3">
                    <Form.Control
                        type="text"
                        value={current && current.item ? getEntityDisplay(current) : ''}
                        readOnly
                        placeholder="entity for spatial filtering"
                        onClick={() => setShowConfig(true)}
                    />

                    { current && current.item ?
                        <InputGroup.Append>
                            <Button variant="outline-secondary" onClick={onClearSelected}>X</Button>
                        </InputGroup.Append>
                        : ''
                    }
                </InputGroup>
        );
    }

    const renderEdit = () => {
        return(
            showConfig ?
                <div style={{backgroundColor: "silver", padding: "7px"}}>
                    <Form.Control as="select" name="spatialEntity"
                        onChange={configItemChanged}
                        defaultValue={current && current.item ? spatialEntities.map((e:IItem) => { return e.item!.name; }).indexOf(current.item!.name) : "-1"}>
                        <option value="-1">Select</option>
                        {spatialEntities.map((item: IItem, i: number) => (
                            <option key={i} value={i}>{getEntityDisplay(item)}</option>
                        ))}
                    </Form.Control>

                    <div style={{paddingTop: "7px"}}>
                        <Button variant="warning" disabled={!isConfigValid} onClick={() => saveOnClick(true)}>Save</Button>
                        <Button variant="link" onClick={() => saveOnClick(false)}>cancel</Button>
                    </div>
                </div>
            : ''
        );
    }

    return (
        <Form.Group controlId="spatialFilter">
            <Form.Label>Spatial Filtering</Form.Label>
            { renderCurrent() }
            { renderEdit() }
        </Form.Group>
    )
}
